import {
  GET_ACCOUNT_INTEGRATIONS_V2,
  GET_ACCOUNT_INTEGRATIONS_V2_SUCCESS,
  GET_ACCOUNT_INTEGRATIONS_V2_ERROR,
  GET_TEMPLATE_INTEGRATIONS_V2,
  GET_TEMPLATE_INTEGRATIONS_V2_SUCCESS,
  GET_TEMPLATE_INTEGRATIONS_V2_ERROR,
  GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2,
  GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_SUCCESS,
  GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_ERROR,
  GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2,
  GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_SUCCESS,
  GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_ERROR,
  GET_LEAD_INTEGRATION_DETAILS_V2,
  GET_LEAD_INTEGRATION_DETAILS_V2_SUCCESS,
  GET_LEAD_INTEGRATION_DETAILS_V2_ERROR,
  DUPLICATE_INTEGRATION_V2,
  DUPLICATE_INTEGRATION_V2_SUCCESS,
  DUPLICATE_INTEGRATION_V2_ERROR,
  DELETE_INTEGRATION_V2,
  DELETE_INTEGRATION_V2_SUCCESS,
  DELETE_INTEGRATION_V2_ERROR,
} from "./actionTypes"
import { CREATE_INTEGRATION_SUCCESS, UPDATE_INTEGRATION_SUCCESS } from "../integration/actionTypes"

const initialState = {
  account_integrations: [],
  template_integrations: [],
  campaign_attached_integrations: [],
  campaign_eligible_integrations: [],
  details_by_id: {},
  account_integrations_loading: false,
  account_integrations_fetched: false,
  template_integrations_loading: false,
  template_integrations_fetched: false,
  campaign_eligible_integrations_loading: false,
  campaign_eligible_integrations_fetched: false,
  campaign_attached_integrations_loading: false,
  details_loading_by_id: {},
  error: null,
}

const invalidateEligibleIntegrations = (state) => ({
  ...state,
  campaign_eligible_integrations: [],
  campaign_eligible_integrations_fetched: false,
})
const upsertIntegrationById = (existingIntegrations = [], incomingIntegration) => {
  if (!incomingIntegration?.id) return existingIntegrations

  const existingIndex = existingIntegrations.findIndex(integration => integration.id === incomingIntegration.id)
  if (existingIndex === -1) return [...existingIntegrations, incomingIntegration]

  const updatedIntegrations = [...existingIntegrations]
  updatedIntegrations[existingIndex] = incomingIntegration

  return updatedIntegrations
}

const deleteIntegrationById = (existingIntegrations = [], integrationId) => {
  if (!integrationId) return existingIntegrations
  return existingIntegrations.filter(integration => integration.id !== integrationId)
}

const syncIntegrationById = (existingIntegrations = [], incomingIntegration) => {
  if (!incomingIntegration?.id) return existingIntegrations
  return existingIntegrations.map(integration => (
    integration?.id === incomingIntegration.id
      ? { ...integration, ...incomingIntegration }
      : integration
  ))
}

const IntegrationV2 = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACCOUNT_INTEGRATIONS_V2:
      return {
        ...state,
        account_integrations_loading: true,
      }

    case GET_ACCOUNT_INTEGRATIONS_V2_SUCCESS:
      return {
        ...state,
        account_integrations: action.payload || [],
        account_integrations_loading: false,
        account_integrations_fetched: true,
      }

    case GET_ACCOUNT_INTEGRATIONS_V2_ERROR:
      return {
        ...state,
        error: action.payload,
        account_integrations_loading: false,
      }

    case GET_TEMPLATE_INTEGRATIONS_V2:
      return {
        ...state,
        template_integrations_loading: true,
      }

    case GET_TEMPLATE_INTEGRATIONS_V2_SUCCESS:
      return {
        ...state,
        template_integrations: action.payload || [],
        template_integrations_loading: false,
        template_integrations_fetched: true,
      }

    case GET_TEMPLATE_INTEGRATIONS_V2_ERROR:
      return {
        ...state,
        error: action.payload,
        template_integrations_loading: false,
      }

    case GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2:
      return {
        ...state,
        campaign_eligible_integrations_loading: true,
      }

    case GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_SUCCESS:
      return {
        ...state,
        campaign_eligible_integrations: action.payload || [],
        campaign_eligible_integrations_loading: false,
        campaign_eligible_integrations_fetched: true,
      }

    case GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_ERROR:
      return {
        ...state,
        error: action.payload,
        campaign_eligible_integrations_loading: false,
      }

    case GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2:
      return {
        ...state,
        campaign_attached_integrations_loading: true,
      }

    case GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_SUCCESS:
      return {
        ...state,
        campaign_attached_integrations: action.payload || [],
        campaign_attached_integrations_loading: false,
      }

    case GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_ERROR:
      return {
        ...state,
        error: action.payload,
        campaign_attached_integrations_loading: false,
      }

    case GET_LEAD_INTEGRATION_DETAILS_V2:
      return {
        ...state,
        details_loading_by_id: {
          ...state.details_loading_by_id,
          [action.payload?.integration_id]: true,
        },
      }

    case GET_LEAD_INTEGRATION_DETAILS_V2_SUCCESS:
      return {
        ...state,
        details_by_id: {
          ...state.details_by_id,
          [action.payload?.id]: action.payload,
        },
        details_loading_by_id: {
          ...state.details_loading_by_id,
          [action.payload?.id]: false,
        },
      }

    case GET_LEAD_INTEGRATION_DETAILS_V2_ERROR:
      return {
        ...state,
        error: action.payload?.error || action.payload,
        details_loading_by_id: {
          ...state.details_loading_by_id,
          [action.payload?.integration_id]: false,
        },
      }

    case DUPLICATE_INTEGRATION_V2:
      return {
        ...state,
        account_integrations_loading: action.payload?.is_template ? state.account_integrations_loading : true,
        template_integrations_loading: action.payload?.is_template ? true : state.template_integrations_loading,
      }

    case DUPLICATE_INTEGRATION_V2_SUCCESS:
      {
        const duplicatedIntegration = action.payload?.integration
        const isTemplate = action.payload?.is_template
        return {
          ...invalidateEligibleIntegrations(state),
          account_integrations: isTemplate ? state.account_integrations : upsertIntegrationById(state.account_integrations, duplicatedIntegration),
          template_integrations: isTemplate ? upsertIntegrationById(state.template_integrations, duplicatedIntegration) : state.template_integrations,
          account_integrations_loading: isTemplate ? state.account_integrations_loading : false,
          template_integrations_loading: isTemplate ? false : state.template_integrations_loading,
          details_by_id: duplicatedIntegration?.id ? {
            ...state.details_by_id,
            [duplicatedIntegration.id]: duplicatedIntegration,
          } : state.details_by_id,
        }
      }

    case DUPLICATE_INTEGRATION_V2_ERROR:
      return {
        ...state,
        error: action.payload?.error || action.payload,
        account_integrations_loading: action.payload?.is_template ? state.account_integrations_loading : false,
        template_integrations_loading: action.payload?.is_template ? false : state.template_integrations_loading,
      }

    case DELETE_INTEGRATION_V2:
      return {
        ...state,
        account_integrations_loading: action.payload?.is_template ? state.account_integrations_loading : true,
        template_integrations_loading: action.payload?.is_template ? true : state.template_integrations_loading,
      }

    case DELETE_INTEGRATION_V2_SUCCESS:
      {
        const deletedIntegration = action.payload?.integration
        const deletedIntegrationId = deletedIntegration?.id
        const isTemplate = action.payload?.is_template

        if (!deletedIntegrationId) {
          return {
            ...state,
            account_integrations_loading: isTemplate ? state.account_integrations_loading : false,
            template_integrations_loading: isTemplate ? false : state.template_integrations_loading,
          }
        }

        const updatedDetailsById = { ...state.details_by_id }
        delete updatedDetailsById[deletedIntegrationId]

        return {
          ...invalidateEligibleIntegrations(state),
          account_integrations: isTemplate ? state.account_integrations : deleteIntegrationById(state.account_integrations, deletedIntegrationId),
          template_integrations: isTemplate ? deleteIntegrationById(state.template_integrations, deletedIntegrationId) : state.template_integrations,
          account_integrations_loading: isTemplate ? state.account_integrations_loading : false,
          template_integrations_loading: isTemplate ? false : state.template_integrations_loading,
          details_by_id: updatedDetailsById,
        }
      }

    case DELETE_INTEGRATION_V2_ERROR:
      return {
        ...state,
        error: action.payload?.error || action.payload,
        account_integrations_loading: action.payload?.is_template ? state.account_integrations_loading : false,
        template_integrations_loading: action.payload?.is_template ? false : state.template_integrations_loading,
      }

    case CREATE_INTEGRATION_SUCCESS:
      {
        const createdIntegrations = Array.isArray(action.payload) ? action.payload : [action.payload]
        let updatedAccountIntegrations = state.account_integrations
        let updatedTemplateIntegrations = state.template_integrations
        const updatedDetailsById = { ...state.details_by_id }

        createdIntegrations.forEach(integration => {
          if (!integration?.id) return

          if (integration?.is_template) {
            updatedTemplateIntegrations = upsertIntegrationById(updatedTemplateIntegrations, integration)
          } else {
            updatedAccountIntegrations = upsertIntegrationById(updatedAccountIntegrations, integration)
          }
          updatedDetailsById[integration.id] = {
            ...(updatedDetailsById[integration.id] || {}),
            ...integration,
          }
        })

        return {
          ...invalidateEligibleIntegrations(state),
          account_integrations: updatedAccountIntegrations,
          template_integrations: updatedTemplateIntegrations,
          details_by_id: updatedDetailsById,
        }
      }

    case UPDATE_INTEGRATION_SUCCESS:
      {
        const updatedIntegrations = action.payload
        const updatedDetailsById = { ...state.details_by_id }
        let updatedAccountIntegrations = state.account_integrations
        let updatedTemplateIntegrations = state.template_integrations

        updatedIntegrations.forEach(integration => {
          if (integration?.id) {
            updatedDetailsById[integration.id] = {
              ...(updatedDetailsById[integration.id] || {}),
              ...integration,
            }
            updatedAccountIntegrations = syncIntegrationById(updatedAccountIntegrations, integration)
            updatedTemplateIntegrations = syncIntegrationById(updatedTemplateIntegrations, integration)
          }
        })

        return {
          ...invalidateEligibleIntegrations(state),
          account_integrations: updatedAccountIntegrations,
          template_integrations: updatedTemplateIntegrations,
          details_by_id: updatedDetailsById,
        }
      }

    default:
      return state
  }
}

export default IntegrationV2
